import { useFormikContext } from 'formik';
import { number } from 'yup';
import { useEffect } from 'react';

import { NavTabs } from '@@/NavTabs';
import { NavContainer } from '@@/NavTabs/NavContainer';

import { ScheduleType } from '../types';

import { useInfo } from './useInfo';
import { defaultValue } from './ScheduledTimeField';
import { FormValues } from './types';
import { UpdateScheduleDetailsFieldset } from './UpdateScheduleDetailsFieldset';
import { RollbackScheduleDetailsFieldset } from './RollbackScheduleDetailsFieldset';

export function ScheduleTypeSelector() {
  const { values, setFieldValue } = useFormikContext<FormValues>();

  const query = useInfo(values.groupIds);

  const hasTimeZone = query.data?.HasLocalTimeZone || false;
  const hasGroupSelected = values.groupIds.length > 0;

  useEffect(() => {
    if (!hasTimeZone || !hasGroupSelected) {
      setFieldValue('scheduledTime', '');
    } else if (!values.scheduledTime) {
      setFieldValue('scheduledTime', defaultValue());
    }
  }, [setFieldValue, hasTimeZone, values.scheduledTime, hasGroupSelected]);

  if (query.isLoading || !query.data) {
    return null;
  }

  return (
    <div className="form-group">
      <div className="col-sm-12">
        <NavContainer>
          <NavTabs
            options={[
              {
                id: ScheduleType.Update,
                label: 'Update',
                children: (
                  <UpdateScheduleDetailsFieldset
                    info={query.data}
                    hasGroupSelected={hasGroupSelected}
                  />
                ),
              },
              {
                id: ScheduleType.Rollback,
                label: 'Rollback',
                children: (
                  <RollbackScheduleDetailsFieldset
                    hasTimeZone={hasTimeZone}
                    hasGroupSelected={hasGroupSelected}
                  />
                ),
              },
            ]}
            selectedId={values.type}
            onSelect={handleChangeType}
          />
        </NavContainer>
      </div>
    </div>
  );

  function handleChangeType(scheduleType: ScheduleType) {
    setFieldValue('type', scheduleType);
  }
}

export function typeValidation() {
  return number()
    .oneOf([ScheduleType.Rollback, ScheduleType.Update])
    .default(ScheduleType.Update);
}
